import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { REFECTH_QUERY_INTERVAL, message } from "@Constants/constant"
import { UserService } from "@Services/User.service"
import { useQuery } from "@tanstack/react-query"

function useFreeslotRQHooks() {
    return useQuery({
        queryKey: [`freeslots`],
        queryFn: async () => await UserService.getFreeSlot(),
        onSuccess: () => {},
        onError: () => {
            ShowToast({ type: "error", message: message.serverError })
        },
        select: (responses) => {
            const data = responses?.data?.data
            const sortedData = data?.sort((a, b) => new Date(a.day) - new Date(b.day))
            return sortedData
        },
        refetchInterval: REFECTH_QUERY_INTERVAL + 5000
    })
}

export { useFreeslotRQHooks }
